import { useContext } from 'react';
import { Role } from '../../api/user/Role';
import { SessionsProvider } from '../../contexts/sessions-context';
import { UserContext } from '../../contexts/user-context';
import { ProtectedRouteProps } from '../../router/type';
import { FounderSessionsPage } from './founder-sessions-page';
import { SessionsPage } from './sessions';

export function Sessions({ user }: ProtectedRouteProps) {
  const { hasRole } = useContext(UserContext);

  return (
    <SessionsProvider>
      {hasRole(Role.Founder) ? (
        <FounderSessionsPage user={user} />
      ) : (
        <SessionsPage user={user} />
      )}
    </SessionsProvider>
  );
}
